import { match, P } from 'ts-pattern'

export const OrderOption = {
  challenge: 'challenge',
  random: 'random',
  newest: 'newest',
  oldest: 'oldest',
  dailyRanking: 'daily-ranking',
  followingNews: 'following-news',
  mostLiked: 'most-liked',
  mostUsed: 'most-used',
  trending: 'trending',
  recommended: 'recommended',
}

export type OrderOptionType = (typeof OrderOption)[keyof typeof OrderOption]

export function isOrderOptionPosSeq(order?: string | null) {
  if (!order) return false
  return [
    OrderOption.oldest,
    OrderOption.mostLiked,
    OrderOption.random,
    OrderOption.challenge,
    OrderOption.dailyRanking,
    OrderOption.followingNews,
    OrderOption.recommended,
    OrderOption.mostUsed,
  ].includes(order)
}

export function isBookmarkOrderOptionPosSeq(order?: string | null) {
  if (!order) return false
  return [OrderOption.newest].includes(order)
}

export function translateOrderOptionToQueryOrderBy(
  order?: OrderOptionType | null,
) {
  return match(order)
    .with(OrderOption.newest, () => '-createdAt')
    .with(OrderOption.oldest, () => '+createdAt')
    .with(OrderOption.mostLiked, () => '-markInfo.likedCount')
    .with(OrderOption.mostUsed, () => '-markInfo.refCount')
    .otherwise(() => undefined)
}

type ModelListQueryArgs = {
  order?: OrderOptionType | null
  keyword?: string
}
export function translateOrderOptionToModelListQuery(args: ModelListQueryArgs) {
  return (
    match(args)
      .with(
        // Keyword is empty
        { order: OrderOption.newest, keyword: P.union(P.nullish, '') },
        () => 'latest',
      )
      .with(
        // Keyword is empty
        { order: OrderOption.trending, keyword: P.union(P.nullish, '') },
        () => 'trending',
      )
      /**
       * Everything else fallback to meilisearch
       */
      .otherwise(() => 'meilisearch')
  )
}
/**
 * Override posSeq if feed is meilisearch
 *
 * @param args
 * @returns
 */
export function getPosSeqAndFeedForModelListQuery(args: ModelListQueryArgs) {
  const feed = translateOrderOptionToModelListQuery(args)
  const posSeq = feed === 'meilisearch' ? true : isOrderOptionPosSeq(args.order)
  return { posSeq, feed }
}

export function translateOrderOptionForArtworkListQuery(
  order: OrderOptionType,
  hasListFilters = false,
) {
  return (
    match({ order, hasListFilters })
      .with({ order: OrderOption.trending }, () => OrderOption.random)
      // `recommended` has no ES feed mapping; fall back to `random` when list filters force the Default path.
      .with(
        { order: OrderOption.recommended, hasListFilters: true },
        () => OrderOption.random,
      )
      .otherwise(() => order)
  )
}
